{
  "version": 1,
  "asset_id": "12a7c1db-4797-42e1-a64b-f8cc151d3064",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/12a7c1db-4797-42e1-a64b-f8cc151d3064/ind-professional-services-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/12a7c1db-4797-42e1-a64b-f8cc151d3064/ind-professional-services-640.webp",
  "original_filename": "ind-professional-services-640.webp",
  "size": 6800,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:10Z"
}
